import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  AfterViewInit
} from '@angular/core';
import { MatIconModule, MatPaginator, MatSort, PageEvent } from '@angular/material';
import { Observable, Subscription } from 'rxjs';
import { ColunasAcoesListPaginator } from './colunas-acoes-list-paginator';
import { ColunasListPaginator } from './colunas-list-paginator';
import { PaginatorHelper } from './paginator-helper';
import { Sort } from '@angular/material/sort';

@Component({
  selector: 'rot-list-paginator',
  templateUrl: './list-paginator.component.html',
  styleUrls: ['./list-paginator.component.scss'],
})
export class ListPaginatorComponent implements OnInit, OnDestroy, AfterViewInit {


  resultsLength = 0;
  provider$: any[] = [];
  paginator$: Observable<any>;
  listaColunas: ColunasListPaginator[] = [];
  displayedColumns = [];
  selectedItem: any;
  interUtilizaPaginacao = true;
  // MatPaginator Output
  pageEvent: PageEvent;

  subscription$: Subscription;

  checkBoxHeader = false;

  isLoading = false;

  @Input() utilizaPaginacao = true;
  @Input() exibirSelecao = false;
  @Input() exibirCheckbox = false;

  @Input() set provider(value: Observable<any>) {
    if (value) {
      this.provider$ = [];
      this.isLoading = true;
      this.subscription$ = value.subscribe(
        (result) => this.pesquisarResult(result),
        (error) => this.pesqusarError(error)
      );
    }

  }

  @Input() acoes: ColunasAcoesListPaginator[] = [];
  @Input() widthColunaAcoes = '120px';

  @Input() set columns(value: ColunasListPaginator[]) {
    if (value) {
      this.listaColunas = value;
      setTimeout(() => {

        if (this.exibirCheckbox) {
          this.displayedColumns.push('colunaCheckbox');
        }
        if (this.exibirSelecao) {
          this.displayedColumns.push('colunaSelecao');
        }
        this.listaColunas.forEach(item => {
          this.displayedColumns.push(item.nameColumn);
        });

        if (this.acoes.length > 0) {
          this.displayedColumns.push('colunaAcoes');
        }
      }, 100);
    }
  }

  @Input() set dados(value) {
    if (value) {
      this.provider$ = value;
    } else {
      this.provider$ = [];
    }
  }

  @Input() paginatorHelper: PaginatorHelper;
  @Output() paginatorHelperChange = new EventEmitter();

  @Output() selecionouItemEvent: EventEmitter<any> = new EventEmitter();

  @Output() pageChange: EventEmitter<any> = new EventEmitter();

  @Output() dadosChange: EventEmitter<any> = new EventEmitter();


  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  @Input() rowClass: (row: any) => string;

  getRowClass(row: any): string {
    return this.rowClass ? this.rowClass(row) : '';
  }

  indicePagina = 0;

  constructor() { }

  ngOnInit() {
    if (this.utilizaPaginacao) {
      this.paginatorHelperChange.emit(this.paginatorHelper);

      if (this.paginator) {
        this.paginator.firstPage();
      }
    }
  }

  ngOnDestroy(): void {
    if (this.subscription$) {
      this.subscription$.unsubscribe();
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.interUtilizaPaginacao = this.utilizaPaginacao, 100);
  }

  private pesquisarResult(result: any) {
    this.checkBoxHeader = false;
    this.isLoading = false;
    if (this.utilizaPaginacao) {
      if (result.quantidade < this.paginator$) {
        this.paginator.firstPage();
      }
      this.provider$ = result.lista;
      this.paginator$ = result.quantidade;

    } else {
      this.provider$ = result;
    }

    this.dispatchDadosChanged();
  }

  private pesqusarError(error: any) {
    this.isLoading = false;
  }

  changePage(event: PageEvent) {

    this.pageEvent = event;
    if (event) {
      if (event.pageIndex === 0) {
        this.paginatorHelper.indicePrimeiroRegistroPagina = 0;
        this.paginatorHelper.tamanhoPagina = event.pageSize
      } else {
        this.paginatorHelper.tamanhoPagina = event.pageSize
        this.paginatorHelper.indicePrimeiroRegistroPagina = event.pageIndex * this.paginatorHelper.tamanhoPagina;
      }

      this.paginatorHelperChange.emit(this.paginatorHelper);

      this.pageChange.emit(event);
    }
  }

  selecinouItem(item) {
    this.selectedItem = item;
    this.selecionouItemEvent.emit(item);
  }

  checkboxChange(row) {
    // TODO

    this.dispatchDadosChanged();
  }

  checkboxChangeAll(event) {
    this.provider$.forEach(e => e.checkboxSelecao = event.checked);

    this.dispatchDadosChanged();
  }

  dispatchDadosChanged() {
    this.dadosChange.emit(this.provider$);
  }

  changeSort(sort: Sort) {
    if (sort) {
      this.paginatorHelper.campoOrdenacao = sort.active;
      this.paginatorHelper.tipoOrdenacao = sort.direction;
      this.pageChange.emit(this.paginatorHelper);
    }
  }
}
